import { useSelector } from "react-redux";
import { useViewport } from "reactflow";
import SoftBox from "components/SoftBox";

export const ActionsWrapper = ({ children, isBooleanNode, isCommon }) => {
   const { isVerticalCanvasDirection } = useSelector((state) => state.designer?.settings);
   const { themeMode } = useSelector((store) => store?.portal?.settings);
   const { zoom } = useViewport();

   const scale = zoom < 1 ? 1 / zoom : 1;

   return (
      <SoftBox
         className={`custom-node-actions ${isVerticalCanvasDirection ? "right-side" : "bottom-side"} ${isBooleanNode && "boolean-node"} ${isCommon && "common-node-actions"}`}
         style={{
            scale,
            transformOrigin: isVerticalCanvasDirection ? "right center" : "center bottom",
            backgroundColor: `${themeMode === "dark" ? "#010409f2" : "#f2f6f9f2"}`,
            padding: "0 12px"
         }}
      >
         {children}
      </SoftBox>
   );
};
